import React, { useState } from "react";
import classNames from "classnames";

export default function SearchItemRoot({ children }) {
    const prefix = "search-item";
    const [focused, setFocused] = useState(false);
    return (
        <div
            className={classNames({ "search-item": true, [`${prefix}-input`]: true, [`${prefix}-focus`]: focused })}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}>
            {children}
        </div>
    );
}
